function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import cloneDeep from 'lodash.clonedeep';
import deepmerge from 'deepmerge';
/**
 * Converts CSS rules to glamor objects.
 * @param {Object} rules1 - the first set of rules to glamorize
 * @param {Object} rules2 - the second set of rules to glamorize
 * @returns {Object} the deeply merged style object
 */

export var merge = function merge(rules1, rules2) {
  var cloned = cloneDeep(rules1);
  return rules2 ? deepmerge(cloned, rules2) : cloned;
};
export var mergeStyles = function mergeStyles(attributes) {
  var getAppliedStyle = function getAppliedStyle(styleArgument) {
    if (typeof styleArgument === 'function') return styleArgument(attributes);else if (typeof styleArgument === 'undefined' || Object.is(styleArgument, null)) return {};
    return styleArgument;
  };

  for (var _len = arguments.length, styleExtensions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    styleExtensions[_key - 1] = arguments[_key];
  }

  var _styleExtensions$map = styleExtensions.map(getAppliedStyle),
      _styleExtensions$map2 = _slicedToArray(_styleExtensions$map, 3),
      baseStyle = _styleExtensions$map2[0],
      componentStyle = _styleExtensions$map2[1],
      instanceStyle = _styleExtensions$map2[2];

  return deepmerge.all([baseStyle, componentStyle, instanceStyle]);
};